import logo_t_small from './../../assets/logos/LogoAnimation/Vector.svg'
import logo_h from './../../assets/logos/LogoAnimation/Vector-0.svg'
import logo_e from './../../assets/logos/LogoAnimation/Vector-1.svg'
import logo_G from './../../assets/logos/LogoAnimation/Vector-2.svg'
import logo_u from './../../assets/logos/LogoAnimation/Vector-3.svg'
import logo_a from './../../assets/logos/LogoAnimation/Vector-4.svg'
import logo_r from './../../assets/logos/LogoAnimation/Vector-5.svg'
import logo_n from './../../assets/logos/LogoAnimation/Vector-7.svg'
import logo_t from './../../assets/logos/LogoAnimation/Vector-8.svg'
import logo_o from './../../assets/logos/LogoAnimation/Vector-9.svg'
import logo_s from './../../assets/logos/LogoAnimation/Vector-11.svg'
import { Grid, Typography } from '@mui/material'

export const LogoAnimationLoader = () => {
    return (
        <Grid container
        display="flex"
        justifyContent="center"
        alignItems="center" flexDirection="column">
            <Grid item marginBottom={10}>
                <Typography variant="h2">We are validating your policy.</Typography>
            </Grid>
            <Grid item sx={{
                '& > *':{ opacity:0, animation: "letterAppearance 2s forwards"}
            }}>
                <img src={logo_t_small} alt="t" style={{animationDelay:'0.5s'}}/>
                <img src={logo_h} alt="h" style={{animationDelay:'1s'}}/>
                <img src={logo_e} alt="e" style={{animationDelay:'0.8s'}}/>
                <img src={logo_G} alt="G" style={{animationDelay:'1.5s', marginRight:'1px'}}/>
                <img src={logo_u} alt="u" style={{animationDelay:'0.2s', marginRight:'1px'}}/>
                <img src={logo_a} alt="a" style={{animationDelay:'0.8s', marginRight:'1px'}}/>
                <img src={logo_r} alt="r" style={{animationDelay:'1.2s', marginRight:'1px'}}/>
                <img src={logo_a} alt="a" style={{animationDelay:'0.2s', marginRight:'1px'}}/>
                <img src={logo_n} alt="n" style={{animationDelay:'0.8s', marginRight:'1px'}}/>
                <img src={logo_t} alt="t" style={{animationDelay:'1.2s', marginRight:'1px'}}/>
                <img src={logo_o} alt="o" style={{animationDelay:'0.5s', marginRight:'1px'}}/>
                <img src={logo_r} alt="r" style={{animationDelay:'1s'  , marginRight:'1px'}}/>
                <img src={logo_s} alt="s" style={{animationDelay:'0.5s', marginRight:'1px'}}/>
            </Grid>
        </Grid>
    )
}
